<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :type-mo-full="true">
    <template v-slot>
      <div id="CYB_PC_MA_01_00" class="modal" data-popup>
        <div class="dialog">
          <header class="dialog-header">
            <h2 class="dialog-title">메뉴 설정</h2>
            <button
              type="button"
              class="dialog-close"
              data-popup-close
              @click="() => emits('close')"
            >
              <span class="c-icon icon-large-x"></span>
              <span class="sr-only">팝업 닫기</span>
            </button>
          </header>

          <div class="dialog-content">
            <div class="dialog-content-inner">
              <div class="c-round-box">
                <ul class="c-dot-list">
                  <li>자주 쓰는 메뉴를 최대 5개까지 설정할 수 있습니다.</li>
                </ul>
              </div>

              <form class="form-wrap">
                <div class="c-check-field col3">
                  <div
                    class="c-checkbox type-sqaure"
                    v-for="(item, idx) in data.init"
                    :key="idx"
                  >
                    <input
                      type="checkbox"
                      :id="item.prgrmId"
                      v-model="data.chkGroup"
                      :value="item.prgrmId"
                      :checked="item.useYn == 'Y'"
                      @change="btnCmd('vali')"
                    />
                    <label :for="item.prgrmId">{{ item.menuSeNm }}</label>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="dialog-footer">
            <div class="c-btn-area">
              <button
                type="button"
                class="c-button type-secondary"
                @click="() => emits('close')"
              >
                <span>취소</span>
              </button>
              <button
                type="button"
                class="c-button type-primary"
                @click="btnCmd()"
              >
                <span>확인</span>
              </button>
            </div>
          </div>
        </div>
        <!-- D: dimmed -->
        <div class="dimmed"></div>
      </div>
    </template>
  </AbstractPop>
</template>

<script setup name="menuSettingPop">
import { onMounted, reactive, defineEmits, defineProps } from "vue";

import * as cmUtil from "@/utils/cmUtil.js";
import * as cmApi from "@/api/cmApi";

import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";

const emits = defineEmits(["close", "select"]);
const props = defineProps({
  data: {},
});

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  setting: {
    list: [],
  },
  chkGroup: [],
  init: [
    {
      checked: false,
      menuSeNm: "주문내역",
      useYn: "N",
      prgrmId: "1",
    },
    {
      checked: false,
      menuSeNm: "출고현황",
      useYn: "N",
      prgrmId: "2",
    },
    {
      checked: false,
      menuSeNm: "매입현황",
      useYn: "N",
      prgrmId: "3",
    },
    {
      checked: false,
      menuSeNm: "배합문의",
      useYn: "N",
      prgrmId: "4",
    },
    {
      checked: false,
      menuSeNm: "업데이트",
      useYn: "N",
      prgrmId: "5",
    },
    {
      checked: false,
      menuSeNm: "색상찾기",
      useYn: "N",
      prgrmId: "6",
    },
    {
      checked: false,
      menuSeNm: "1:1 문의",
      useYn: "N",
      prgrmId: "7",
    },
    {
      checked: false,
      menuSeNm: "공지사항",
      useYn: "N",
      prgrmId: "8",
    },
  ],
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  //자주 찾는 메뉴 셋팅
  for (let i in props.data) {
    for (let j in data.init) {
      if (props.data[i].prgrmId == data.init[j].prgrmId) {
        if (props.data[i].useYn == "Y") {
          data.init[j].useYn = "Y";
          data.chkGroup.push(props.data[i].prgrmId);
        }
      }
    }
  }

  data.setting.list = props.data;
}

async function btnCmd(cmd = "") {
  //유효성 체크
  if (cmd == "vali") {
    if (data.chkGroup.length > 5) {
      await cmUtil.alert("메뉴는 최대 5개까지 설정할 수 있습니다.");
      data.chkGroup.pop();
      return;
    }
  }
  // 확인 > 자주찾는 메뉴 등록
  else {
    let array = [];
    if (data.chkGroup.length > 0) {
      for (var i in data.chkGroup) {
        let param = {};
        param.prgrmId = data.chkGroup[i];

        if (data.chkGroup[i] == "1") {
          param.menuSeNm = "주문내역";
          param.useYn = "Y";
        } else if (data.chkGroup[i] == "2") {
          param.menuSeNm = "출고현황";
          param.useYn = "Y";
        } else if (data.chkGroup[i] == "3") {
          param.menuSeNm = "매입현황";
          param.useYn = "Y";
        } else if (data.chkGroup[i] == "4") {
          param.menuSeNm = "배합문의";
          param.useYn = "Y";
        } else if (data.chkGroup[i] == "5") {
          param.menuSeNm = "업데이트";
          param.useYn = "Y";
        } else if (data.chkGroup[i] == "6") {
          param.menuSeNm = "색상찾기";
          param.useYn = "Y";
        } else if (data.chkGroup[i] == "7") {
          param.menuSeNm = "1:1 문의";
          param.useYn = "Y";
        } else if (data.chkGroup[i] == "8") {
          param.menuSeNm = "공지사항";
          param.useYn = "Y";
        }

        array.push(param);
      }
    } else {
      for (let i in data.setting.list) {
        data.setting.list[i].useYn = "N";
      }

      array = data.setting.list;
    }

    const res = await cmApi.mergeUserBookmarkMenu(array);
    if (res.resultCode == 200) {
      emits("select");
      emits("close");
    }
  }
}
</script>
